var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudPandaImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 222,
    viewBox: "0 0 357 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.972 7.44177L127.225 8.40934L126.972 7.44177C80.0819 19.6834 45.3588 38.8952 24.3665 63.4926C3.33977 88.1304 -3.84414 118.098 4.23334 151.614C10.4589 177.453 34.8798 194.774 65.9376 205.628C97.0459 216.5 135.113 221 169.197 221C215.966 221 262.287 212.908 296.292 198.759L296.293 198.759L297.483 198.262L320.09 216.831L321.696 218.15L321.725 216.072L322.148 185.344L322.999 184.779C342.539 171.81 353.643 156.503 355.715 139.25C356.936 129.083 354.194 116.932 348.255 104.204C342.31 91.4625 333.126 78.0675 321.357 65.3822C283.962 25.0722 229.776 1 176.384 1C159.97 1 143.347 3.16751 126.972 7.44177Z",
    fill: "white",
    stroke: "#371B45",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudPandaImg);
export default __webpack_public_path__ + "static/media/cloudPandaImg.12379c21f37607a1b8179c0644b0d7b9.svg";
export { ForwardRef as ReactComponent };